<main>
  <form [formGroup]="credentialForm">
    <div class="container my-5 pt-5 pt-md-0">
      <div class="shadow rounded-4 p-4 p-md-5 bg-white m-auto register-container">
        <div class="m-auto">
          <h1 class="page-title">Registreren</h1>
        </div>
        <div *ngIf="accountErrorMessage" class="alert alert-danger m-auto mb-5" role="alert">
          {{ this.accountErrorMessage }}
        </div>
        <div class="row mb-4">
          <div class="m-auto input-row">
            <a [routerLink]="['/account/registreren-organisatie/']" class="organiser-link mb-5"><i class="bi bi-chevron-right"></i>Ik ben een organisator</a>
          </div>
        </div>
        <div class="row mb-4">
          <div class="m-auto">
            <label for="password-input" class="form-label">Voornaam</label>
            <input type="text" class="form-control" formControlName="firstName" id="firstname-input">
            <div class="errors" *ngIf="firstname?.errors && formSubmitted">
              <small class="text-danger" *ngIf="firstname?.errors?.['required']">Dit veld is vereist.</small>
              <small class="text-danger" *ngIf="firstname?.errors?.['minlength']">Voer een voornaam in dat uit minstens 2 karakters bestaat.</small>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="m-auto">
            <label for="email-input" class="form-label">Email</label>
            <input type="email" class="form-control" formControlName="email" id="email-input">
            <div class="errors" *ngIf="email?.errors && formSubmitted">
              <small class="text-danger" *ngIf="email?.errors?.['required']">Dit veld is vereist.</small>
              <small class="text-danger" *ngIf="email?.errors?.['email']">Voer een geldig emailadres in.</small>
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <div class="m-auto">
            <label for="password-input" class="form-label">Wachtwoord</label>
            <input type="password" class="form-control" formControlName="password" id="password-input">
            <div class="errors" *ngIf="password?.errors && formSubmitted">
              <small class="text-danger" *ngIf="password?.errors?.['required']">Dit veld is vereist.</small>
              <small class="text-danger" *ngIf="password?.errors?.['minlength']">Voer een wachtwoord in dat uit minstens 6 karakters bestaat.</small>
            </div>
          </div>
        </div>
        <div class="row m-auto">
          <button type="submit" class="btn btn-primary mb-2 btn-register m-auto" (click)="signUp()">Registreren</button>
          <p class="form-text text-center">Heb je al een account? <span [routerLink]="['/account/inloggen']" class="url">Log in</span></p>
        </div>
      </div>
    </div>
  </form>
</main>
